import { Toast } from "bootstrap";

export const toastNotify = (type ='danger', message='') => {
    if(message){
        const idGenerate = Math.floor((Math.random() * 1000000) + 1);
        const htmlToast = `<div id="` + idGenerate + `" class="toast fade bg-white mb-2 border-0" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="4000"><div class="d-flex bg-${type}"><div class="toast-body first-text-uppercase fs-16px text-white">
            ${message}
        </div><button type="button" class="btn-close ms-auto me-2 mt-2 mmwh-22px" data-bs-dismiss="toast" aria-label="Close" title="Close"></button></div>
        </div>`;
        document.getElementById('toastContainer').insertAdjacentHTML("afterbegin", htmlToast);

        var getIdToast = document.getElementById(idGenerate);
        var toast = new Toast(getIdToast);
        toast.show();
        
        getIdToast.addEventListener('hidden.bs.toast', function () {
            setTimeout(() => {
                this.remove();
            }, 600);
        });
    }
}

export const noImageHandle = (e) => {
    e.target.src = "../images/no-image_small.png";
}

export const loadingData = (active) => {
    if(active){
        document.querySelector('body').classList.add('loading-data');
    }else{
        document.querySelector('body').classList.remove('loading-data');
    }
}